(function () {
	'use strict';
	angular.module('app.core')
		.service('flexColumns', flexColumns);

	flexColumns.$inject = (['tableRenderService']);
	function flexColumns(tableRenderService) {
		var flexFields = globalConfig.customer.flexFields;
		var columnsBySourceType = {};
		_.each(flexFields, function (field, fieldName) {
			if (!columnsBySourceType[field.sourceType]) {
				columnsBySourceType[field.sourceType] = [];
			}
			columnsBySourceType[field.sourceType].push(buildColumnDefinition(field, fieldName));
		});

		return {
			addFlexColumnsBySourceType: addFlexColumnsBySourceType
		};
		
		function addFlexColumnsBySourceType(sourceTypes, columns) {
			var flexColumns = [];
			var columnsForSource;
			_.each(sourceTypes, function (sourceType) {
				columnsForSource = columnsBySourceType[sourceType];
				if (columnsForSource) {
					flexColumns = flexColumns.concat(columnsForSource);
				}
			});
			flexColumns = _.sortBy(flexColumns, 'columnOrder');
			return columns.concat(flexColumns);
		}

		function buildColumnDefinition(field, fieldName) {
			var columnDefinition = {
				id: fieldName,
				display: field.displayName,
				sort: field.indexed,
				show: false,
				width: 100,
				columnOrder: field.columnOrder
			};
			if (field.description) {
				columnDefinition.uibTooltip = field.description;
			}
			switch (field.storageType) {
			case 'number':
				columnDefinition.renderer = tableRenderService.decimal;
				break;
			case 'integer':
				columnDefinition.renderer = tableRenderService.integer;
				break;
			case 'currency':
				columnDefinition.renderer = tableRenderService.currency;
				break;
			case 'date':
				columnDefinition.renderer = tableRenderService.dateRenderer;
				columnDefinition.convertTimeZone = true;
				break;
			}
			return columnDefinition;
		}
	}

	function hideFromSuppliers() {
		return globalConfig.user.role !== 'Supplier';
	}
})();
